var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteWarningItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.884 0.531516C10.538 -0.122484 9.46196 -0.122484 9.11596 0.531516L0.115959 17.5315C0.0349422 17.6839 -0.00522229 17.8546 -0.000621372 18.0272C0.00397955 18.1997 0.0531889 18.368 0.142212 18.5159C0.231235 18.6637 0.357036 18.786 0.507356 18.8707C0.657676 18.9555 0.827389 18.9998 0.999959 18.9995H19C19.1724 18.9999 19.342 18.9555 19.4922 18.8708C19.6424 18.7861 19.7681 18.6639 19.8571 18.5162C19.946 18.3684 19.9951 18.2002 19.9997 18.0278C20.0042 17.8554 19.964 17.6847 19.883 17.5325L10.884 0.531516ZM11 15.9995H8.99996V13.9995H11V15.9995ZM8.99996 11.9995V6.99952H11L11.001 11.9995H8.99996Z",
    fill: "#CB0B0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteWarningItem);
export default __webpack_public_path__ + "static/media/delete-warning-item.d93eed77ece5e6dabecb9065e45c94ae.svg";
export { ForwardRef as ReactComponent };